import { FC, InputHTMLAttributes } from 'react';

import { Checkbox, Root } from './Switch.styled';

export const Switch: FC<InputHTMLAttributes<HTMLInputElement>> = ({ className, style, checked, disabled, ...rest }) => {
  return (
    <Root className={className} style={style} checked={checked} disabled={disabled}>
      <Checkbox {...rest} type='checkbox' defaultChecked={checked} disabled={disabled} />
    </Root>
  );
};
